module.exports = __webpack_public_path__ + "assets/retina_CircleCenterDetailed.40179137b25daca728a9f0c76bceae1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleCenterDetailed.png
// module id = 637
// module chunks = 0